document.addEventListener('DOMContentLoaded', () => {

  // 🚧 SAFETY CHECK: Wenn keine Footer-Help-Blöcke existieren -> Script komplett beenden
  if (!document.querySelector('.footer-help')) return;

  const helpBlocks = document.querySelectorAll('.footer-help');

  helpBlocks.forEach(block => {
    const title = block.querySelector('.footer-help__title');
    const icon = block.querySelector('.footer-help__icon');
    const content = block.nextElementSibling;

    // Anfangszustand
    content.style.maxHeight = '0px';
    content.style.overflow = 'hidden';

    block.addEventListener('click', e => {

      // Wenn ein <a> geklickt wird – NICHT toggeln
      if (e.target.tagName.toLowerCase() === 'a') return;

      // Andere Blöcke schließen
      helpBlocks.forEach(otherBlock => {
        const otherContent = otherBlock.nextElementSibling;
        const otherIcon = otherBlock.querySelector('.footer-help__icon');
        if (otherContent !== content) {
          otherContent.style.maxHeight = '0px';
          otherContent.classList.remove('open');
          otherIcon.classList.remove('open');
        }
      });

      // Diesen Block toggeln
      const isOpen = content.classList.contains('open');

      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.maxHeight = '0px';
        });
        content.classList.remove('open');
        icon.classList.remove('open');
      } else {
        content.classList.add('open');
        icon.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });

    // Transition Ende: max-height entfernen
    content.addEventListener('transitionend', e => {
      if (e.propertyName === 'max-height' && content.classList.contains('open')) {
        content.style.maxHeight = 'none';
      }
    });
  });

}); 